import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import { getTextAlign } from '../utils/rtl';
import { FONTS } from '../constants/config';
import { Ionicons } from '@expo/vector-icons';

import { tokens } from '@design';
interface PendingDeletionBadgeProps {
  onPress?: () => void;
  compact?: boolean;
}

export default function PendingDeletionBadge({ onPress, compact = false }: PendingDeletionBadgeProps) {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  const content = (
    <View style={[styles.badge, compact && styles.compactBadge, isRTL && { flexDirection: 'row-reverse' }]}>
      <Ionicons name="time-outline" size={compact ? 12 : 14} color="#854D0E" />
      <Text style={[styles.text, compact && styles.compactText, isRTL && styles.rtlText]}>
        {t('deletion.pendingDeletion')}
      </Text>
    </View>
  );

  if (onPress) {
    return (
      <TouchableOpacity onPress={onPress}>
        {content}
      </TouchableOpacity>
    );
  }

  return content;
}

const getStyles = (isRTL: boolean) => StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.absolute["1"],
    backgroundColor: '#FEF9C3',
    paddingVertical: tokens.spacing.absolute["1"],
    paddingHorizontal: tokens.spacing.absolute["2"],
    borderRadius: tokens.radii.absolute["radius-12"],
    borderWidth: tokens.spacing.absolute["px"],
    borderColor: '#FDE68A',
  },
  compactBadge: {
    paddingVertical: tokens.spacing.absolute["0_5"],
    paddingHorizontal: tokens.spacing.absolute["1_5"],
  },
  text: {
    fontSize: tokens.typography.paragraph["paragraph caption font size"],
    color: '#854D0E',
    fontFamily: FONTS.medium,
  },
  compactText: {
    fontSize: 10,
  },
  rtlText: {
    textAlign: getTextAlign(isRTL),
  },
});

const styles = getStyles(true);
